import React from 'react';
import classNames from 'classnames';

import styles from './dashicon.pcss';

type Props = {
	icon: string;
	title: string;
};

/**
 * @link https://developer.wordpress.org/resource/dashicons
 *
 * @example <Dashicon icon="yes" />
 * @todo Look into this instead https://www.npmjs.com/package/@wordpress/icons
 * @param          object       props
 * @param {string} object.icon
 * @param {string} object.title
 */
const Dashicon = ( {icon, title}: Props ) => {
	const classes = {
		dashicons: true,
		[ 'dashicons-' + icon ]: true,
	};
	if ( typeof styles[ icon ] !== 'undefined' ) {
		classes[ styles[ icon ] ] = true;
	}

	return <span className={classNames( classes )} title={title} />;
};

export default Dashicon;
